import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  buttonGroup: {
    ...theme.standarts('buttonGroup'),

    backgroundColor: theme.getColor('buttonGroup', 'basic', 'value'),

    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    borderRadius: theme.get('buttonGroup', 'border.radius'),

    position: 'relative',
    width: 'fit-content'
  }
}));

const useVariantStyles = createUseStyles((theme) => ({}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStyles
      }
    };

    static propTypes = {
      variant: PropTypes.string
    };

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { classes, children, variant, ...props } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.buttonGroup,
        variant && classes.variant[variant]
      );

      return (
        <div {...props} className={mergedClassName}>
          {children}
        </div>
      );
    }
  }
);
